module.exports = __webpack_public_path__ + "img/anxiety-icon-3.5adae7f6.svg";